import ContractingFooter from "features/contracting/components/ContractingFooter";
import ContractingStepFormProps from "features/contracting/models/ContractingStepFormProps";
import { useContractingStep } from "features/contracting/hooks/useContractingStep";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import ContractingState from "infrastructure/store/contracting/ContractingState";
import { useForm } from "features/shared/forms/hooks/useForm";
import ProductListSubForm from "features/contracting/components/product/ProductListSubForm";
import { ProductEnumDTO } from "features/shared/enums/dynamic/ProductEnumDTO";
import { productFormValidations } from "./productFormValidation";
import Alert from "features/shared/alerts/components/Alert";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { useContractingCustomerTypeValue } from "features/contracting/hooks/useContractingCustomerTypeValue";
import { Commodity } from "features/shared/enums/commodity";

const ProductFormSection = (props: ContractingStepFormProps) => {
  // store
  const stepData = useSelector<IAppState, ContractingState>(
    (store) => store.contracting
  ).progress.steps[props.actualStep.component];

  const configuration = useSelector<IAppState, ContractingState>(
    (store) => store.contracting
  ).configuration;

  const commodity = useContractingCustomerTypeValue<Commodity>("commodity");
  const category = useContractingCustomerTypeValue<string>(
    "contractCategoryCode"
  );

  const products: ProductEnumDTO[] = configuration.products!.filter(
    (x) => x.commodity === commodity && x.contractCategory === category
  );

  // form hook
  const formHandler = useForm({
    initialValues: stepData.values ?? undefined,
    initialValidations: productFormValidations(),
  });

  const {
    values,
    errors,
    valideteForm,
    bindCheckField,
    setFormValue,
    getFormValue,
  } = {
    ...formHandler,
  };

  // form-step hook
  const { onPrevClick, onSaveClick, onNextClick } = useContractingStep({
    ...props,
    formValues: values,
    validateForm: valideteForm,
  });

  // side-effects
  // automatic setting of ContractCategory
  useEffect(() => {
    const productCode = getFormValue("productCode");
    const product = products.find(x => x.code === productCode);

    if (product) {
      setFormValue("contractDurationPresetCode", product.contractDurationPresetCode);
      setFormValue("contractDurationTypeCode", product.contractDurationTypeCode);
    }
  }, [getFormValue("productCode")]);

  // render
  return (
    <div>
      <ProductListSubForm products={products} bindCheckField={bindCheckField} />

      <RenderWrapper isVisible={() => errors["productCode"] !== undefined}>
        <Alert
          alertObj={{ alertType: "Danger", message: errors["productCode"] }}
          className="mt-2"
        />
      </RenderWrapper>

      <ContractingFooter
        onPrevClick={onPrevClick}
        onNextClick={onNextClick}
        onSaveClick={props.enableSaveBtn ? onSaveClick : undefined}
      />
    </div>
  );
};

export default ProductFormSection;
